import { Box, Grid, Skeleton, Theme, useMediaQuery } from '@mui/material';

interface WishlistItemCardSkeletonProps {
  isSubHeadingFirst?: boolean;
}
export const WishlistItemCardSkeleton: React.FC<WishlistItemCardSkeletonProps> = ({ isSubHeadingFirst }) => {
  const isMobile = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'));
  const imageSize: string = isMobile ? '3rem' : '5rem';
  return (
    <Box sx={{ boxShadow: 10, borderRadius: '0.5rem', p: 3 }}>
      <Grid container spacing={1} justifyContent="space-between" alignItems="center">
        <Grid item>
          <Skeleton variant="rectangular" height="2rem" width="2rem" />
        </Grid>
        <Grid item>
          <Skeleton variant="circular" height="2.5rem" width="2.5rem" />
        </Grid>
      </Grid>
      <Box sx={{ mt: 2 }}>
        <Grid container spacing={2.5}>
          <Grid item>
            <Skeleton variant="circular" height={imageSize} width={imageSize} />
          </Grid>
          <Grid item xs>
            {isSubHeadingFirst && <Skeleton width="33%" sx={{ mb: 0.5 }} />}
            <Skeleton sx={{ mb: 1.5 }} variant="rectangular" width="100%" height="1.5rem" />
            {!isSubHeadingFirst && <Skeleton width="33%" sx={{ mb: 0.5 }} />}
            <Skeleton width="50%" sx={{ mb: 0.5 }} />
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};
